<template>
  <div class="main">
    <c-panel>
      <form-produto :paramId="$route.params.id" v-on:onSubmitProduto="onSubmitProduto"></form-produto>
    </c-panel>
  </div>
</template>
<script>
import formProduto from "./form"

export default {
  methods: {
    onSubmitProduto () {
      this.$router.push('/admin/financeiro/produto')
    }
  },
  components: { formProduto }
}
</script>

